import {useCallback, useEffect, useState} from 'react';

const getWidth = () => window.innerWidth;
const getHeight = () => window.innerHeight;

export const useSizeDOMWindow = () => {
	const [width, setWidth] = useState(getWidth());
	const [height, setHeight] = useState(getHeight());
	const handler = useCallback(() => {
		setHeight(getHeight);
		setWidth(getWidth);
	}, []);
	useEffect(() => {
		window.addEventListener('orientationchange', handler);
		window.addEventListener('resize', handler);
		return () => {
			window.removeEventListener('orientationchange', handler);
			window.removeEventListener('resize', handler)
		};
	}, [handler]);
	return {height, width};
};